import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Logo } from "../components/AppShell";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { adminForgot, formatErr } from "../lib/api";
import { toast } from "sonner";
import { Mail } from "lucide-react";

export default function AdminForgot() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await adminForgot(email);
      setSent(true);
      toast.success("Si el email existe, te hemos enviado un enlace");
    } catch (err) { toast.error(formatErr(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="app-shell">
      <div className="app-frame flex flex-col">
        <header className="px-5 py-4 border-b border-slate-100">
          <Logo size={32} withWordmark />
        </header>
        <main className="flex-1 px-5 py-8 fade-in flex flex-col justify-center">
          <h1 className="text-3xl font-[Outfit] font-extrabold tracking-tight text-slate-900">
            Restablecer contraseña
          </h1>
          <p className="text-sm text-slate-600 mt-1">
            Te enviaremos un enlace para crear una nueva contraseña.
          </p>

          {sent ? (
            <div className="mt-6 rounded-2xl border border-emerald-200 bg-emerald-50 p-5 text-center">
              <Mail className="w-9 h-9 mx-auto text-emerald-600" />
              <h3 className="mt-3 font-[Outfit] font-bold text-slate-900">Revisa tu bandeja</h3>
              <p className="text-sm text-slate-700 mt-1">
                Si el email existe, recibirás un enlace en pocos segundos. Expira en 30 minutos.
              </p>
              <button onClick={() => navigate("/admin/login")}
                className="mt-4 text-sm font-semibold text-[var(--el-red)] underline underline-offset-4">
                Volver al login
              </button>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4" data-testid="forgot-form">
              <div className="space-y-1.5">
                <Label className="text-sm">Email del admin</Label>
                <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                  placeholder="enlineamadrid@gmail.com"
                  data-testid="input-forgot-email" required />
              </div>
              <Button type="submit" disabled={loading}
                className="btn-primary h-12 rounded-xl w-full font-semibold"
                data-testid="btn-forgot-submit">
                {loading ? "Enviando..." : "Enviar enlace"}
              </Button>
              <button type="button" onClick={() => navigate("/admin/login")}
                className="block mx-auto text-sm text-slate-500 underline underline-offset-4">
                Volver
              </button>
            </form>
          )}
        </main>
      </div>
    </div>
  );
}
